import { actionDuckUtils } from 'wanderu-ducks-utils';

import sliceNamespace from '../../types';

const namespace = 'POLL_INSURANCE_STATUS';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

export {
    actions,
    namespace,
    reducer,
    selectors,
};
